import { render } from "./Folder.vue?vue&type=template&id=4ef0515a&scoped=true"
import script from "./Folder.vue?vue&type=script&lang=ts"
export * from "./Folder.vue?vue&type=script&lang=ts"

import "./Folder.vue?vue&type=style&index=0&id=4ef0515a&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-4ef0515a"

export default script